import { serviceOperationApi } from "./api";

export async function liberarTecnicoTaller({ ticketId, countryId, accessToken }) {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const { data: tecnicoTaller } = await serviceOperationApi.get(
    "/GetTecnicoTaller",
    { headers },
  );

  if (!tecnicoTaller.some((item) => item.id_devoluciones === ticketId)) {
    const err = new Error("Ticket no encontrado");
    err.code = "NOT_FOUND";
    throw err;
  }

  const res = await serviceOperationApi.post(
    "/LiberarTecnicoTaller",
    { document: { id: ticketId, nombre_usuario: "", pais: countryId.toString() } },
    { headers },
  );
  return res;
}